<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-avatar :size="size || 18" v-bind="attrs" v-on="on">
          <img :src="src" class="avatar-img"/>
        </v-avatar>
      </template>
      <span>
        {{ title }}
      </span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: "UserProfilePhoto",
  props: {
    profilePhoto: null,
    size: null,
    title: null,
    blob: null,
  },
  data() {
    return {
      blobDatUrl: 0,
    };
  },
  computed: {
    src() {
      if (this.blob && this.blob !== null) {
        this.blobToSrc(this.blob);
        return this.blobDatUrl;
      }
      if (!this.profilePhoto) {
        return process.env.VUE_APP_API_ROOT + "/images/no-avatar.png";
      }
      //LEVAM_USERS_FILES_STORAGE_PATH
      if (
        process.env.NODE_ENV === "development" &&
        this.profilePhoto !== null
      ) {
        return (
          process.env.VUE_APP_API_ROOT +
          "/LEVAM_USERS_FILES_STORAGE_PATH/" +
          this.profilePhoto
        );
      }
      return this.$apiURL + this.profilePhoto;
    },
  },
  methods: {
    blobToSrc(blob) {
      let convertBlobToBase64 = (blob) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onerror = reject;
          reader.onload = () => {
            resolve(reader.result);
          };
          reader.readAsDataURL(blob);
        });

      convertBlobToBase64(blob).then((result) => {
        this.blobDatUrl = result;
      });
    },
  },
};
</script>

<style scoped>
.avatar-img{
  border: 1px solid gray;
}
</style>
